import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useWizard } from "react-use-wizard";
import AnimatedTextInput from "../../components/animatedTextInput";
import React, { useState } from "react";
import SingleChoiceV2WithoutSubmit from "../../components/singleChoiceV2WithoutSubmit";
import { useTranslation } from "react-i18next";

//TODO: Generalise name, since it is reusable
function MedicalHistoryStep({
  initState = null,
  onSubmitHandler,
  qKey,
  question,
  questionCode,
  choices,
  yesChoiceCode,
  yesDescription = "",
  hideLibrary = false,
  onSubmitText = null,
}) {
  const { previousStep, nextStep } = useWizard();
  const [textValue, setTextValue] = useState(
    initState && initState["textValueInit"] ? initState["textValueInit"] : ""
  );
  const [selectedChoice, setSelectedChoice] = useState(
    initState && initState["selectedChoiceInit"]
      ? initState["selectedChoiceInit"]
      : { value: null, text: null }
  );
  const { t } = useTranslation();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setTextValue(value);
  };

  const onOptionChange = (choiceInfo) => {
    setSelectedChoice(choiceInfo);
  };

  const isYesSelected = () => {
    console.log(selectedChoice);
    return selectedChoice.value === "Yes";
  };

  const canSubmit = () => {
    console.log(selectedChoice);
    return (
      (isYesSelected() && textValue != "") ||
      (!isYesSelected() && selectedChoice.value !== null)
    );
  };

  const next = () => {
    let _choices = [];
    if (isYesSelected()) {
      _choices.push({
        text: textValue,
        correct: true,
        code: yesChoiceCode,
      });
    } else {
      _choices.push({
        text: selectedChoice.text,
        correct: true,
        code: selectedChoice.id,
      });
    }
    let response = {
      _state: {
        selectedChoiceInit: selectedChoice,
        textValueInit: textValue,
      },
      formatted_response: {
        type: "RADIO",
        question: question,
        code: questionCode,
        choices: _choices,
      },
    };
    onSubmitHandler({ [qKey]: response });
    nextStep();
  };

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={previousStep}
        title={t("hi.title")}
        hideLibrary={hideLibrary}
      />
      <div className="body_content">
        <div className="inner_body">
          <SingleChoiceV2WithoutSubmit
            question={question}
            choices={choices}
            qKey="medical-history"
            onChange={onOptionChange}
            selectedChoice={selectedChoice}
          />
          <div className="fill_form light_fill_form">
            <div className="field_group">
              <span className="txt_lbl">
                {yesDescription !== "" ? yesDescription : t("hi.yesText")}
                <sup>&nbsp;*</sup>
              </span>
              <AnimatedTextInput
                value={textValue}
                onChange={handleChange}
                isDisabled={!isYesSelected()}
                id="text-value"
              />
            </div>
          </div>
        </div>
        <div className="btn_block bottom_button d-flex justify-content-center">
          <button
            className="btn btn_primary nextstep_cta"
            disabled={!canSubmit()}
            onClick={() => next()}
          >
            {onSubmitText ? onSubmitText : t("login.DOBSTEP.button")}
          </button>
        </div>
      </div>
    </>
  );
}

export default MedicalHistoryStep;
